import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";

import React from "react";

import draftLogo from "@/assets/images/draftLogo.png";
import PDFPortrait from "@/components/Common/PDFs/PDFPortrait";
import PDFHeaderGlobo from "@/pages/Globo/Components/PDFHeaderGlobo";

const styles = StyleSheet.create({
  page: {
    /*  paddingTop: 60,
     paddingHorizontal: 60,
     fontSize: 10,
     lineHeight: 1.6, */
    position: "relative",
  },
  watermark: {
    position: "absolute",
    top: "-20%",
    left: "-5%",
    width: 600,
    opacity: 0.3,
    zIndex: -1,
  },

  header: {
    marginBottom: 0,
  },
  dateSection: {
    fontSize: 10,
    marginBottom: 20,
  },
  greeting: {
    fontSize: 10,
    marginBottom: 15,
  },
  paragraph: {
    fontSize: 10,
    marginBottom: 10,
    lineHeight: 1.5,
    textAlign: "justify",
  },
  bold: {
    fontWeight: "bold",
  },
  tableTitle: {
    fontSize: 10,
    fontWeight: "bold",
    backgroundColor: "#8B7BA8",
    color: "#FFFFFF",
    padding: 5,
    marginTop: 15,
    marginBottom: 0,
  },
  table: {
    width: "100%",
    borderLeft: "0.5pt solid #000",
    borderRight: "0.5pt solid #000",
    borderBottom: "1pt solid #000",
  },
  tableRow: {
    flexDirection: "row",
    borderTop: "0.5pt solid #000",
  },
  tableCell: {
    fontSize: 9,
    padding: 5,
    borderRight: "0.5pt solid #000",
  },
  tableCellLeft: {
    width: "40%",
  },
  tableCellRight: {
    width: "60%",
  },
  tableCellLast: {
    borderRight: "none",
  },
  footerText: {
    fontSize: 10,
    marginTop: 20,
    marginBottom: 15,
    lineHeight: 1.5,
    textAlign: "justify",
  },
  preparedBy: {
    fontSize: 10,
    marginTop: 30,
    marginBottom: 10,
  },
  note: {
    fontSize: 10,
    fontWeight: "bold",
    marginTop: 10,
  },
});

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return date.toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const formatShortDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const LoaPDF = ({ pdfTitle, data }) => {
  return (
    <PDFPortrait pdfTitle={pdfTitle} Header={PDFHeaderGlobo} Footer={() => null}>
      <View style={styles.page}>
        {data?.statusName !== "Approved" && <Image src={draftLogo} style={styles.watermark} fixed />}
        <View style={styles.header}>
          <Text style={styles.dateSection}>Date: {formatDate(data?.dateSubmitted || data?.createdDate)}</Text>
          <Text style={styles.greeting}>Dear Sir/Madam:</Text>
          <Text style={styles.paragraph}>
            This serves as a confirmation that patient below is entitled to avail the discount on <Text style={styles.bold}>{data?.productName}</Text>{" "}
            under <Text style={styles.bold}>{data?.programName}:</Text>
          </Text>
        </View>

        <Text style={styles.tableTitle}>Discount Information</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>LOA No.</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.referenceNo}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Quantity</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>
              {data?.quantity} {data?.uom}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Valid Until</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{formatDate(data?.expiryDate)}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Purchasing Account</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.purchasingAccountName}</Text>
          </View>
        </View>

        <Text style={styles.tableTitle}>Patient Information</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Patient Serial</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.patientCode}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Attending Physician</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.doctorName}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Cycle Number</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.cycleNo}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Infusion Schedule</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{formatDate(data?.infusionDate)}</Text>
          </View>
        </View>

        <Text style={styles.footerText}>
          This Letter of Availment (LOA) is valid for <Text style={styles.bold}>30 days</Text> from "Date of Issuance". If the infusion is not made
          after 30 days from the date when this LOA was issued (top leftmost date), please contact and coordinate with the Program Coordinator.
        </Text>

        <Text style={styles.preparedBy}>
          Prepared by: {data?.submittedByName} ({formatShortDate(data?.dateSubmitted)})
        </Text>

        <Text style={styles.note}>Note: This is an electronically generated Letter of Availment and does not require a signature.</Text>
      </View>
    </PDFPortrait>
  );
};

export default React.memo(LoaPDF);
